import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userActions } from '../../_actions';
import LoadingOverlay from 'react-loading-overlay';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import './style.css';
import ReactPaginate from 'react-paginate';
import { isMobile } from "react-device-detect";
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { BiArrowBack } from "react-icons/bi";
import { GrAddCircle } from "react-icons/gr";
import AddFollowUpModal from './components/AddFollowUpModal';
import dayjs from 'dayjs';


class moreDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      size: 10,
      pageNo: 1,
      keyWord: '',
      offset: 0,
      AddBalanceModal: false,
      emsfield: true,
      massagefield: false,
      attendencefield: false,
      orderfield: false,
      classfield: false,
      loginHistoryfield: false,
      parkingfield: false,
      txfield: false,
      DeductBalanceModal: false,
      fieldsUserUpdate: {},
      fieldsUser: {},
      errorsUpdateQuote: {},
      errorsUpdate: {},
      calenderDate: '',
      followUpModal: false,
      // fieldsFollowUp: {},
      fieldsFollowUp: {
        // dateAndTimeValue: moment(new Date()).format("YYYY-MM-DD HH:mm")
        dateAndTimeValue: dayjs().hour(10).minute(0)
      },
      errorsFollowUp: {},
      followUpModal: false,
      dateAndTimeValue: "",
      show: true
    }
  }

  componentDidMount() {
    let data = {
      "id": this.props.match.params.id
    }
    let reqData = {
      "leadId": this.props.match.params.id,
      "keyWord": this.state.keyWord,
      "pageNo": this.state.pageNo,
      "size": this.state.size

    }

    console.log('reqData_______1111111111_____reqData', reqData);
    this.props.dispatch(userActions.getLeadById(data))
    this.props.dispatch(userActions.getFollowUpListByLeadId(reqData))
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.users.addUserSuccess) {
      console.log('999999999999');
      return {
        ...nextProps,
        fieldsUserUpdate: {},
        fieldsUser: {},
        errorsUpdateQuote: {},
        errorsUpdate: {},
        AddBalanceModal: false,
        addQuoteModal: false,
        DeductBalanceModal: false,
        calenderDate: ''

      }
    } else {
      return {
        ...nextProps,

      }
    }
  }

  handleAddFollowUpModal = (data) => {
    this.setState({
      followUpModal: true,
      show: true,
      fieldsFollowUp: { dateAndTimeValue: dayjs().hour(10).minute(0) },
      fieldsUserUpdate: data
    })
  }

  handleBack = () => {
    this.props.history.goBack();
  };

  handlePageClick = (data) => {
    console.log("data  ", data);
    let offset = Math.ceil(data.selected * this.state.size);
    this.setState({ offset: offset, pageNo: data.selected + 1 });
    let datatemp = {
      "leadId": this.props.match.params.id,
      "keyWord": this.state.keyWord,
      "pageNo": data.selected + 1,
      "size": this.state.size
    }

    this.props.dispatch(userActions.getFollowUpListByLeadId(datatemp));
  }

  handleOpenCreateModalUpdatePassword = (data) => {
    this.setState({ AddBalanceModal: true, fieldsUserUpdate: { id: this.props.match.params.id } });
  }
  handleOpenCreateModalPassword = (data) => {
    this.setState({ DeductBalanceModal: true, fieldsUser: { id: this.props.match.params.id } });
  }

  handleUpdatePasswordHideModal = () => {
    this.setState({ AddBalanceModal: false });
  }

  handleUpdateHideModal = () => {
    this.setState({ DeductBalanceModal: false });
  }

  handleValidationUpdateUserDeduct = () => {
    let calenderDate = this.state.calenderDate;
    let errorsUpdate = {};
    let formIsValid = true;

    //name
    if (!calenderDate || calenderDate === "") {
      formIsValid = false;
      errorsUpdate["calenderDate"] = "Cannot be empty";
    }

    console.log("errorsUpdateerrorsUpdateerrorsUpdate", errorsUpdate);
    this.setState({ errorsUpdate: errorsUpdate });
    return formIsValid;
  }

  handleValidationUpdateUser = () => {
    let calenderDate = this.state.calenderDate;
    let errorsUpdateQuote = {};
    let formIsValid = true;

    //name
    if (!calenderDate || calenderDate === "") {
      formIsValid = false;
      errorsUpdateQuote["calenderDate"] = "Cannot be empty";
    }
    console.log("errorsUpdateQuoteerrorsUpdateQuoteerrorsUpdateQuote", errorsUpdateQuote);
    this.setState({ errorsUpdateQuote: errorsUpdateQuote });
    return formIsValid;
  }

  inputChangeFollowUp = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    let fieldsFollowUp = this.state.fieldsFollowUp;
    let errorsFollowUp = this.state.errorsFollowUp;
    fieldsFollowUp[name] = value;
    errorsFollowUp[name] = "";
    console.log(name, value);
    this.setState({ fieldsFollowUp, errorsFollowUp });
  }

  createFollowUp = () => {
    if (this.handleValidationComment()) {
      let reqData = {
        // "leadId": this.state.fieldsFollowUp.id,
        "leadId": this.props.match.params.id,
        "comment": this.state.fieldsFollowUp.comment,
        "reminderDate": this.state.fieldsFollowUp.dateAndTimeValue,
        // "reminderDate": this.state.dateAndTimeValue ? moment(new Date(this.state.dateAndTimeValue)).format("YYYY-MM-DD HH:mm") : null
      }
      let paginationData = {
        "keyWord": this.state.keyWord,
        "pageNo": this.state.pageNo,
        "size": this.state.size,
        "status": this.state.fieldsFollowUp.status,
      }

      // let followUpReqData = {
      //   "leadId": this.state.fieldsUserUpdate.id,
      // }

      let followUpReqData = {
        "leadId": this.props.match.params.id,
        "keyWord": this.state.keyWord,
        "pageNo": this.state.pageNo,
        "size": this.state.size

      }

      console.log('reqData??????/', reqData);

      console.log("createFollowUp>>>>>>>>>>>>>>>>>>>>>>>", reqData);
      this.props.dispatch(userActions.createFollowUp(reqData, followUpReqData));
      // this.props.dispatch(userActions.getFollowUpListByLeadId(followUpReqData))

      this.setState({ fieldsFollowUp: {}, followUpModal: false })
    }
  }

  handleValidationComment = () => {
    let fieldsFollowUp = this.state.fieldsFollowUp;
    let errorsFollowUp = {};
    let formIsValid = true;

    //comment
    if (!fieldsFollowUp["comment"] || fieldsFollowUp["comment"] === "") {
      formIsValid = false;
      errorsFollowUp["comment"] = "Comment cannot be empty";
    }

    console.log("errorsFollowUperrorsFollowUperrorsFollowUp", errorsFollowUp);
    this.setState({ errorsFollowUp: errorsFollowUp });
    return formIsValid;
  }

  handleFollowUpHideModal = () => {
    this.setState({
      followUpModal: false,
      fieldsFollowUp: {
        dateAndTimeValue: dayjs().hour(10).minute(0)
      },
    })
  }

  setDateAndTimeValue = (event) => {
    this.setState({ dateAndTimeValue: event });
  }

  handleGoBack = () => {
    this.props.history.goBack();
  };

  handleDateChange = (newValue) => {
    let fieldsFollowUp = this.state.fieldsFollowUp;
    fieldsFollowUp["dateAndTimeValue"] = newValue

    this.setState({ fieldsFollowUp });
  };

  handleCalender = () => {
    this.setState({ show: false, fieldsFollowUp: { ...this.state.fieldsFollowUp, dateAndTimeValue: "" } });
  };



  render() {

    let { users } = this.props;
    let { loading, leadData, followUpItems, followUpTotal } = users;
    // let { getUserProfile } = users;

    console.log('RENDER______________________________________________________', leadData);

    return (

      <>
        <div>
          <LoadingOverlay
            active={loading}
            className="temp001"
            spinner
            text='Please wait...' />
        </div>


        <div className="flex flex-col flex-1 overflow-hidden overflow-x-auto overflow-y-auto">

          <main className="relative flex-1 ">
            <button className="flex items-center px-6 py-2 text-sm font-medium text-white capitalize bg-blue-500 rounded-md" onClick={() => this.props.history.goBack()}>Go Back</button>
            <div className='flex w-full px-4 py-4 bg-gray-100 shadow-lg lg:space-x-10 sm:space-x-2' >
              <div className='items-center py-10'>
                <h2 className='px-4 text-4xl font-semibold'>{leadData && leadData.requirement ? leadData.requirement : "-"}</h2>
                <div className='flex'>
                  <div>
                    <p className='px-4 py-1'>Name : </p>
                    <p className='px-4 py-1'>Source : </p>
                    <p className='px-4 py-1'>Status : </p>
                    <p className='px-4 py-1'>Location : </p>
                    <p className='px-4 py-1'>Company Name : </p>
                    <p className='px-4 py-1'>Date : </p>
                  </div>
                  <div>
                    <p className='px-4 py-1'>{leadData && leadData.name ? leadData.name : "-"}</p>
                    <p className='px-4 py-1'>{leadData && leadData.source ? leadData.source : "-"}</p>
                    <p className='px-4 py-1'>{leadData && leadData.status ? leadData.status : "-"}</p>
                    <p className='px-4 py-1'>{leadData && leadData.location ? leadData.location : "-"}</p>
                    <p className='px-4 py-1'>{leadData && leadData.companyName ? leadData.companyName : "-"}</p>
                    <p className='px-4 py-1'>{leadData && leadData.calenderDate ? leadData.calenderDate : "Invad Date"}</p>
                  </div>
                </div>
              </div>
            </div>
            <section className="p-6 space-y-6 bg-white border rounded-md">
              <div className="flex-wrap justify-between w-full item-center">
                <div className="flex justify-between ">
                  <div className="flex space-x-6">
                    <div onClick={this.handleGoBack} className='p-1 text-gray-600 border border-gray-400 rounded-full cursor-pointer hover:bg-blue-400 hover:border-blue-400 hover:text-white'><BiArrowBack className='w-6 h-6' /></div>
                    <h3 className="text-xl font-semibold ">Follow Up</h3>
                  </div>
                  <div class="rounded-lg font-medium text-white capitalize bg-blue-500 cursor-pointer p-2" onClick={() => this.handleAddFollowUpModal(leadData)}>
                    Add FollowUp
                  </div>
                </div>
                <div className="pb-2 mt-4 overflow-hidden overflow-x-auto ">
                  <div className="max-w-full ">
                    <div className="inline-block min-w-full ">
                      <div className="">
                        <table className="min-w-full border-0 divide-y ">
                          <thead className="bg-gray-200">
                            <tr className="text-sm font-semibold text-left text-gray-500 uppercase">
                              <th className="px-6 py-3 whitespace-nowrap">#</th>
                              <th className="px-6 py-3 whitespace-nowrap">Username</th>
                              <th className="px-6 py-3 whitespace-nowrap">comment</th>
                              <th className="px-6 py-3 whitespace-nowrap">Reminder Date</th>
                              <th className="px-6 py-3 whitespace-nowrap">Creation Date/Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {followUpItems && followUpItems.length > 0 ?
                              followUpItems.map((element, index) => (<React.Fragment key={element.id}>
                                <tr key={element.id} className="bg-white border-b border-black border-opacity-10 text-sm text-gray-600 font-medium">
                                  <td className="px-6 py-3 whitespace-nowrap">
                                    {this.state.offset + index + 1}</td>
                                  <td className="px-6 py-3 whitespace-nowrap">
                                    {element && element.userId && element.userId.userName ? element.userId.userName : "-"}
                                  </td>
                                  <td className="px-6 py-3">
                                    <div className="relative">
                                      <div class="targetablepx-4 tooltip px-6 py-3 cursor-pointer">
                                        <span className='top-0 left-0 p-6 mx-auto -mt-4 text-sm text-black bg-gray-200 rounded tooltip-text'>
                                          {element && element.comment ? element.comment : ""}</span>
                                        {element && element.comment.substring(0, 20) ? element.comment.substring(0, 20) + "..." : element.comment}
                                      </div>
                                    </div>
                                    {/* {element && element.comment ? element.comment : "-"} */}
                                  </td>
                                  <td className="px-6 py-3 whitespace-nowrap">
                                    {moment(new Date(parseInt(element.reminderDate))).utcOffset("+05:30").format("YYYY-MM-DD HH:mm")}
                                  </td>
                                  <td className="px-6 py-3 whitespace-nowrap">
                                    {moment(new Date(parseInt(element.createdAt))).utcOffset("+05:30").format("YYYY-MM-DD HH:mm")}
                                  </td>
                                </tr>
                              </React.Fragment>))
                              : (<tr className="bg-white bg-opacity-5 " >
                                <td className="col-span-3 px-6 py-3 text-sm font-medium text-gray-500 whitespace-nowrap">Not found</td>
                              </tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {/* Table Pagination Section */}
                  {
                    isMobile ?
                      <nav className="relative z-0 flex justify-end mt-5 w-76">
                        {
                          followUpTotal && followUpTotal > 10 ?
                            <ReactPaginate
                              previousLabel={'Prev'}
                              nextLabel={'Next'}
                              breakLabel={'...'}
                              breakClassName={'break-me'}
                              pageCount={followUpTotal / this.state.size}
                              marginPagesDisplayed={1}
                              pageRangeDisplayed={1}
                              onPageChange={this.handlePageClick}
                              containerClassName={'pagination'}
                              pageClassName={'page-cls'}
                              activeClassName={'active'}
                            />
                            : null}
                      </nav> : <nav className="relative z-0 flex justify-end mt-5 w-76">
                        {
                          followUpTotal && followUpTotal > 10 ?
                            <ReactPaginate
                              previousLabel={'Previous'}
                              nextLabel={'Next'}
                              breakLabel={'...'}
                              breakClassName={'break-me'}
                              pageCount={followUpTotal / this.state.size}
                              marginPagesDisplayed={3}
                              pageRangeDisplayed={3}
                              onPageChange={this.handlePageClick}
                              containerClassName={'pagination'}
                              pageClassName={'page-cls'}
                              activeClassName={'active'}
                            />
                            : null}
                      </nav>
                  }
                </div>
              </div>
            </section>
          </main>
          <AddFollowUpModal
            fieldsFollowUp={this.state.fieldsFollowUp}
            errorsFollowUp={this.state.errorsFollowUp}
            inputChangeFollowUp={this.inputChangeFollowUp}
            createFollowUp={this.createFollowUp}
            handleFollowUpHideModal={this.handleFollowUpHideModal}
            followUpModal={this.state.followUpModal}
            show={this.state.show}
            handleDateChange={this.handleDateChange}
            handleCalender={this.handleCalender}
          />
        </div>
      </>

    );
  }
}
function mapStateToProps(state) {
  const { users } = state;
  return {
    users
  };
}
export default withRouter(connect(mapStateToProps)(moreDetails));